"use strict";

const VISIBLE_CLASS = "is-visible";

const SELECTORS = {
    MESSAGE: ".js-message",
    MESSAGE_BUTTON: ".js-message__close",
    PAGE_HEADER: ".page-header",
    BODY: "body",
    STICKY_BUTTON: ".fixed-button, .program-header__cta, .season-header__cta, .sticky-button, .special-events-header__cta", // For pages with sticky buy buttons
    INNER: ".global-alert__inner"
};

let showMessageListener;

function showMessage(elem) {
    document.querySelector(SELECTORS.BODY).classList.add("js-message-active");
    elem.classList.add(VISIBLE_CLASS);
    const inner = document.querySelector(SELECTORS.INNER);
    let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

    // Add spacing for sticky buy buttons when 999 pixels wide or less
    if (vw <= 999) {
        document.querySelectorAll(SELECTORS.STICKY_BUTTON).forEach(stickyButton => {
            stickyButton.style.bottom = inner.offsetHeight + 'px';
        });
    } else {
        document.querySelectorAll(SELECTORS.STICKY_BUTTON).forEach(stickyButton => {
            stickyButton.style.bottom = 0;
        });
    }
}

function hideMessage(elem) {
    document.querySelector(SELECTORS.BODY).classList.remove("js-message-active");
    return elem.classList.remove(VISIBLE_CLASS);
}

(function() {
    const messages = document.querySelectorAll(SELECTORS.MESSAGE);

    if (messages.length === 0) {
        return false;
    }

    if (messages.length) {
        messages.forEach(message => {
            const messageId = message.getAttribute("data-message-id");
            const messageStorageKey = "app.message-hidden-" + messageId;
            const messageButton = message.querySelector(SELECTORS.MESSAGE_BUTTON);
            let isHidden;

            try {
                isHidden = localStorage.getItem(messageStorageKey);
            } catch (e) {
                console.warn(e);
            }

            // bind resize listener to showMessage() so that offset can be applied/removed as viewport width changes
            if (!isHidden) {
                showMessageListener = showMessage.bind(null, message)
                window.addEventListener('resize', showMessageListener)
                showMessage(message)
            }

            messageButton.addEventListener("click", function(evt) {
                evt.preventDefault();

                // remove listener when cookie banner has been dismissed and reset the offset
                window.removeEventListener('resize', showMessageListener)

                document.querySelectorAll(SELECTORS.STICKY_BUTTON).forEach(stickyButton => {
                    stickyButton.style.bottom = 0;
                });

                hideMessage(message);

                try {
                    localStorage.setItem(messageStorageKey, true);
                } catch (e) {
                    console.warn(e);
                }
            });
        });
    }
})();
